var render = function render(){var _vm=this,_c=_vm._self._c;return _c('node-view-wrapper',{staticClass:"brezel-link"},[(_vm.entity && !_vm.editor.options.editable)?_c('EntityLink',{attrs:{"entity":_vm.entity}},[_vm._v(" "+_vm._s(_vm.node.textContent)+" ")]):_c('span',[_c('node-view-content')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }